import React, { useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native';

/**
 * Deep link / legacy route: selalu dialihkan ke Beranda + popup spin baru.
 * Layar wheel penuh lama telah dihapus — semua akses (app & QR) memakai modal di HomeScreen.
 */
export default function SpinningWheelScreen({ navigation, route }) {
  useEffect(() => {
    const programCode = route.params?.programCode ?? null;
    navigation.replace('MainTabs', {
      screen: 'Home',
      params:
        programCode != null && String(programCode).trim() !== ''
          ? {
              openSpinFromQr: true,
              spinProgramCode: String(programCode).trim(),
              spinQrScanNonce: Date.now(),
            }
          : { openSpinFromQr: true, spinQrScanNonce: Date.now() },
    });
  }, [navigation, route.params?.programCode]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#F8FAFC' }}>
      <ActivityIndicator size="large" color="#64748B" />
    </View>
  );
}
